import type { ReactElement } from 'react';
import styled from 'styled-components';
import type { SubscriptionAccountInfo } from './types';

const Container = styled.div`
  margin-top: var(--spacer-32px);
  padding-bottom: var(--spacer-20px);
  border-bottom: 1px solid #e4e8f0 !important;

  img {
    max-width: var(--spacer-24px);
  }
`;

export const Subscription = ({
  stripeURL
}: {
  nextBillingDate?: SubscriptionAccountInfo.Subscription['nextBillingDate'];
  stripeURL?: string;
}): ReactElement => (
  <Container>
    <h2 className='text-dark font-size-20px font-weight-bold'>Subscription</h2>
    <a href={stripeURL ?? ''}
      target='_blank'
      rel='noopener noreferrer'
    >View Subscriptions</a>

  </Container>
);
